// Per-request server-render data store.
//
// This app renders the React tree to a string once per request. For pages
// whose data comes from the API (not a static import), the data is fetched
// first, stashed here, and the tree is rendered *synchronously* immediately
// after — so the component can read it during server render and produce full
// HTML (rather than relying on the client to hydrate from a data island).
//
// Set a field right before the synchronous renderToString and reset it
// straight after. Because set → render → reset happens with no await in
// between, concurrent requests cannot interleave. On the client this module
// is never written to (components read the data island / API instead).
export const serverData = {}
